import {
  Scene,
  CubeTexture,
  AssetsManager,
  CubeTextureAssetTask,
} from 'babylonjs'

export const loadEnvTexture = (src: string, scene: Scene): CubeTexture =>
  new CubeTexture(src, scene)

export const loadEnvTextureAssetTask = (
  src: string,
  assetsManager: AssetsManager
): CubeTextureAssetTask => {
  return assetsManager.addCubeTextureTask('skyboxTask', src)
}
